import { createTheme } from '@mui/material/styles';

const defaultTheme = createTheme();

export const theme = createTheme({
	palette: {
		primary: {
			main: "#343a40",
			contrastText: '#fff'
		},
		secondary: {
			main: "#2e7d32",
			contrastText: '#fff'
		},
	},
	typography: {
		h1: {
			fontSize: '3rem',
			fontWeight: 200,
		},
		h2: {
			fontSize: '3rem',
			fontWeight: 200,
		},
		h3: {
			fontSize: '2.5rem',
			fontWeight: 200,
		},
	},
	// toolbar at the top of a list view
	actionButtons: {
		textAlign: "right",
		marginBottom: defaultTheme.spacing(2),
		"& button": {
			margin: defaultTheme.spacing(0, 0, 0, 3),
		},
	},
	descriptionPaper: {
		padding: defaultTheme.spacing(2, 4),
		marginBottom: defaultTheme.spacing(2),
		[defaultTheme.breakpoints.down("sm")]: {
			padding: defaultTheme.spacing(1, 2),
		},
	},
	progress: {
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		margin: "auto",
	}
});
  